import { LoadingSpinner } from '@components/atoms';

export const DropdownLoadingSpinnerWrapper = () => {
	return (
		<div className="flex h-[30px] w-full items-center justify-center overflow-hidden">
			<LoadingSpinner />
		</div>
	);
};
